/* Muskoka first-touch capture. First-party cookies only. No query strings or personal data stored. */
(function () {
  try {
    var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
    var P = new URLSearchParams(location.search);
    var cur = {};
    KEYS.forEach(function (k) { var v = P.get(k); if (v) cur[k] = v.slice(0, 200); });

    function read(n) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    function write(n, v, days) {
      document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;max-age=' + days * 86400 + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
    }
    function stripUrl(u) { try { var x = new URL(u); return x.origin + x.pathname; } catch (e) { return ''; } }
    function host(u) { try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }

    var refRaw = document.referrer || '';
    var external = refRaw && host(refRaw) !== location.hostname.replace(/^www\./, '');
    var ref = external ? stripUrl(refRaw) : '';
    var hasClick = !!(cur.gclid || cur.gbraid || cur.wbraid || cur.fbclid);

    function touch() {
      var src = cur.utm_source || (cur.gclid || cur.gbraid || cur.wbraid ? 'google' : cur.fbclid ? 'facebook' : (external ? host(refRaw) : 'direct'));
      var med = cur.utm_medium || (cur.gclid || cur.gbraid || cur.wbraid ? 'cpc' : cur.fbclid ? 'paid_social' : (external ? 'referral' : 'none'));
      return {
        s: src, m: med, c: cur.utm_campaign || '', t: cur.utm_term || '', ct: cur.utm_content || '',
        lp: location.origin + location.pathname, r: ref, d: new Date().toISOString(),
        g: cur.gclid || '', gb: cur.gbraid || '', wb: cur.wbraid || '', fb: cur.fbclid || ''
      };
    }

    if (!read('mk_ft')) write('mk_ft', JSON.stringify(touch()), 365);
    if (Object.keys(cur).length || external) write('mk_lt', JSON.stringify(touch()), 90);
  } catch (e) { /* never break the page */ }
})();

/* Carry first touch onto (1) Klaviyo popup sign-ups in HubSpot and (2) the Shopify cart, so orders keep it. */
(function () {
  try {
    var HS_PORTAL = '44861363', HS_FORM = '87ea20ba-3c99-46bc-b59c-7ae58e5a65c3'; // quiet form, no notifications
    function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
    function json(s) { try { return JSON.parse(s) || {}; } catch (e) { return {}; } }
    function touches() {
      var ft = json(cookie('mk_ft')), lt = json(cookie('mk_lt'));
      return {
        mk_ft_source: ft.s || '', mk_ft_medium: ft.m || '', mk_ft_campaign: ft.c || '', mk_ft_term: ft.t || '', mk_ft_content: ft.ct || '',
        mk_ft_landing_page: ft.lp || '', mk_ft_referrer: ft.r || '', mk_ft_date: ft.d || '', mk_ft_gclid: ft.g || '', mk_ft_gbraid: ft.gb || '',
        mk_ft_wbraid: ft.wb || '', mk_ft_fbclid: ft.fb || '', mk_lt_source: lt.s || '', mk_lt_medium: lt.m || '', mk_lt_campaign: lt.c || '', mk_lt_gclid: lt.g || ''
      };
    }

    // (1) Klaviyo sign-up form submitted with an email: attach first touch to the HubSpot contact.
    window.addEventListener('klaviyoForms', function (e) {
      try {
        var d = e && e.detail; if (!d || d.type !== 'submit') return;
        var md = d.metaData || {}, email = md.$email || md.email || '';
        if (!email || email.indexOf('@') < 0) return;
        var t = touches(), fields = [{ name: 'email', value: email }, { name: 'mk_form_name', value: 'klaviyo-signup' }, { name: 'mk_form_page_url', value: location.origin + location.pathname }];
        Object.keys(t).forEach(function (k) { if (t[k]) fields.push({ name: k, value: String(t[k]).slice(0, 250) }); });
        fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + HS_PORTAL + '/' + HS_FORM, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
          body: JSON.stringify({ submittedAt: String(Date.now()), fields: fields, context: { hutk: cookie('hubspotutk') || undefined, pageUri: location.origin + location.pathname, pageName: document.title } })
        }).catch(function () {});
      } catch (err) { /* never break the page */ }
    });

    // (2) Cart has items and no first touch yet: save it as hidden cart attributes (they become order attributes).
    function syncCart() {
      if (!cookie('mk_ft') || sessionStorage.getItem('mk_cart_ft')) return;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c || !c.item_count) return;
        sessionStorage.setItem('mk_cart_ft', '1');
        if (c.attributes && c.attributes._mk_ft_source) return;
        var t = touches(), a = {};
        Object.keys(t).forEach(function (k) { if (t[k]) a['_' + k] = String(t[k]).slice(0, 250); });
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) });
      }).catch(function () {});
    }
    if (document.readyState === 'complete') setTimeout(syncCart, 1500); else window.addEventListener('load', function () { setTimeout(syncCart, 1500); });
    document.addEventListener('cart:updated', function () { try { sessionStorage.removeItem('mk_cart_ft'); } catch (e) {} setTimeout(syncCart, 500); });
  } catch (e) { /* never break the page */ }
})();
